const Config = {
  API_URL: process.env.NODE_ENV === "production" ? "/auth-api" : "/auth-api",

  FRONTEND_URL:
    process.env.NODE_ENV === "production"
      ? "https://hobo.video"
      : "http://localhost:8080",

  SITE_URL:
    process.env.NODE_ENV === "production"
      ? "https://hobo.video"
      : "http://localhost:8080",

  // Country-page media always lives in the live `hobo.video` bucket, even
  // when this app is running on staging — there is no separate staging copy.
  MEDIA_URL: "https://s3.ap-south-1.amazonaws.com/hobo.video/country-pages",
};

export { Config };
